<template>
  <aside class="menu app-sidebar animated" :class="{ slideInLeft: show, slideOutLeft: !show }">
    <p class="menu-label">
      General
    </p>
    <ul class="menu-list">

      <li v-for="(item, index) in menuItemsWithPermissions()" :key="index">
        <span v-if="item.prefix" v-html= "item.prefix"></span>
        <router-link :to="{ name: item.name, params: item.params }" :exact="true" :aria-expanded="isExpanded(item) ? 'true' : 'false'"
                     v-if="item.path" @click.native="expandMenu(item)">
          <span class="icon is-small"><i :class="['mdi', item.meta.icon]"></i></span>
          {{ item.meta.label || item.name }}
          <span class="icon is-small is-angle" v-if="item.children && item.children.length">
            <i class="mdi mdi-chevron-down"></i>
          </span>
        </router-link>
        <a :aria-expanded="isExpanded(item)" v-else @click="expandMenu(item)">
          <div class="columns is-variable is-1">
            <div class="column is-narrow">
              <span class="icon is-small"><i :class="['mdi', item.meta.icon]"></i></span>
            </div>
            <div class="column">
              {{ item.meta.label || item.name }}
            </div>
            <div class="column is-narrow">
               <span class="icon is-small is-angle" v-if="item.children && item.children.length">
            <i class="mdi mdi-chevron-down"></i>
          </span>
            </div>
          </div>
        </a>
        <expanding v-if="item.children && item.children.length">
          <ul v-show="isExpanded(item)">
            <li v-for="(subItem,index) in childrenWithPermissions(item)" :key="index">
              <router-link :to="{ name: subItem.name , params: item.params }" exact>
                {{ subItem.meta.label || subItem.name }}
              </router-link>
            </li>
          </ul>
        </expanding>
      </li>
    </ul>
  </aside>
</template>

<script>
  import Expanding from 'vue-bulma-expanding'
  import {mapGetters, mapActions} from 'vuex'

  export default {
    components: {
      Expanding
    },
    props: {
      show: Boolean
    },
    data () {
      return {
        pkg: this.$store.state.pkg
      }
    },
    created () {
      var requirements = []
      requirements.reduce((p, fn) => p.then(fn), Promise.resolve())
      this.expandParent(this.$route)
    },
    mounted () {
    },
    computed: {
      ...mapGetters('menu', ['menuItems', 'isExpanded']),
      ...mapGetters('security', ['HasPermission', 'UserToken', 'Provinces', 'Clubs'])
    },
    methods: {
      ...mapActions('menu', ['expandMenu']),
      expandParent (route) {
        let parent = this.getParentFromRoute(route)
        if (parent && !this.isExpanded(parent)) {
          this.expandMenu(parent)
        }
      },
      menuItemsWithPermissions () {
        return this.menuItems.filter((item) => {
          return !item.hidden && (!item.meta.permission || this.HasPermission(item.meta.permission))
        })
      },
      childrenWithPermissions (item) {
        return item.children.filter((subItem) => {
          return !subItem.meta.permission || this.HasPermission(subItem.meta.permission)
        })
      },
      getParentFromRoute (route) {
        return this.menuItems.find((i) => {
          return (i.path && i.path === route.path && i.params === route.props) || (i.children && i.children.some((c) => {
            return c.path && c.path === route.path && c.params === route.props
          }))
        })
      }
    },
    watch: {
      $route (route) {
        this.expandParent(route)
      }
    }
  }
</script>

<style lang="scss">
  @import "../../assets/colors.scss";

  .app-sidebar {
    position: fixed;
    top: 41px;
    left: 0;
    bottom: 0;
    padding: 20px 0 50px;
    width: 180px;
    min-width: 45px;
    max-height: 100vh;
    height: calc(100% - 50px);
    z-index: 2;
    background: #FFF;
    box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);
    overflow-y: auto;
    overflow-x: hidden;

    .icon {
      vertical-align: baseline;

      &.is-angle {
        position: absolute;
        right: 10px;
        transition: transform 0.377s ease;
      }
    }

    .menu-label {
      padding-left: 5px;
    }

    .menu-list {
      li a {
        &[aria-expanded="true"] {
          .is-angle {
            transform: rotate(180deg);
          }
        }
      }

      li a + ul {
        margin: 0 10px 0 15px;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?10b42534